import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-dialog',
  standalone: true,
  imports: [],
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.scss',
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'app-dialog',
  },
})
export class DialogComponent {}
